var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoxDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 1.89998,
    width: 25.2,
    height: 25.2,
    rx: 3,
    stroke: "#C3C3C3",
    strokeWidth: 3.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxDefault);
export default __webpack_public_path__ + "static/media/CheckBoxDefault.a224962679668e0c3aa714ca25f10a39.svg";
export { ForwardRef as ReactComponent };